<template>
  <div id="app">
    <h1>vue-load-image</h1>
    <button @click="handleChangeImage">Change image</button>
    <vue-load-image>
      <img
        slot="image"
        :src='src'
      />
      <img
        src="https://john015.github.io/vue-load-image/static/image-loader.gif"
        slot="preloader"
      />
      <div slot="error">Image load failed</div>
    </vue-load-image>
  </div>
</template>

<script>
import VueLoadImage from 'vue-load-image'
export default {
  name: 'App',
  data () {
    return {
      src: 'https://picsum.photos/500/600/?random'
    }
  },
  methods: {
    handleChangeImage () {
      const randomImageNumber = Math.floor(Math.random() * 999) + 1
      this.src = 'https://picsum.photos/500/600/?image=' + randomImageNumber
    }
  },
  components: {
    'vue-load-image': VueLoadImage
  }
}
</script>

<style>
body {
  margin: 0px;
  padding: 0px;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 60px 0px 0px 60px;
}
button {
  height: 38px;
  font-size: 16px;
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid #2c3e50;
  outline: none;
  background-color: white;
  cursor: pointer;
  -webkit-appearance: none;
}

@media screen and (max-width: 500px) {
  #app {
    margin: 0 5vw;
  }
  img {
    position: absolute;
    left: 2vw;
    width: 96vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue